<template>
  <nav class="deluxe-breadcrumbs d-print-none" aria-label="Breadcrumb">
    <ul>
      <template v-for="(item, index) in resolvedItems" :key="item.title">
        <li :class="{ active: index === resolvedItems.length - 1 }">
          <router-link v-if="item.isRouterLink" :to="item.link">
            {{ item.title }}
          </router-link>
          <a v-else :href="item.link">
            {{ item.title }}
          </a>
        </li>
        <span v-if="index !== resolvedItems.length - 1" class="deluxe-breadcrumbs__separator">/</span>
      </template>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'DeluxeBreadcrumbs',
  computed: {
    resolvedItems() {
      return [
        {
          link: '/directory/user',
          title: this.$t('Directory'),
          isRouterLink: true
        },
        {
          link: this.$route.fullPath,
          title: this.$t(this.$route.meta.breadcrumbTitle || this.$route.name || 'Directory'),
          isRouterLink: true
        }
      ]
    }
  }
}
</script>
